import React from 'react'

const LenderWhatYouGain = () => {
  return (
    <section id="c-sectionHowYouBenefit" className="c-sectionWrapper">
		<div className="container">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold">What you gain </h5>
				<div className="row justify-content-lg-center">
					<div className="col-lg-7 col-md-12">						
						{/* <!-- <p className="c-para22Regular">Lorem Ipsum is simply dummy text of the printing and type and setting industry Lorem Ipsum is simply dummy.</p> --> */}
					</div>
				</div>
			</div>

			<div className="row c-hybBoxesWrapper">
				<div className="col-md-4 col-sm-6 col-xs-12">
					<div className="c-hybBox">
						<div className="c-hybBoxIcon">
							<img src="./images/lender/hyb_1.png" alt="" title="" />
						</div>
						<div className="c-hybBoxTitle">Extend your auto loan portfolio through financing </div>
						<ul className="c-hybBoxList">
							<li>originate more green finance profitably</li>
							<li>finance loans with compelling offers</li>
							<li>acquire new customers</li>
						</ul>
					</div>
				</div>
				<div className="col-md-4 col-sm-6 col-xs-12">
					<div className="c-hybBox">
						<div className="c-hybBoxIcon">
							<img src="./images/lender/hyb_2.png" alt="" title="" />
						</div>
						<div className="c-hybBoxTitle">Modernize the digital finance experience</div>
						<ul className="c-hybBoxList">
							<li>Streamline the application process for consumers </li>
							<li>Fraud-free approvals through automated processes</li>
							<li>Finayo will manage all aspects of the process including stips and lien perfection </li>
						</ul>
					</div>
				</div>
				<div className="col-md-4 col-sm-6 col-xs-12">
					<div className="c-hybBox">
						<div className="c-hybBoxIcon">
							<img src="./images/lender/hyb_3.png" alt="" title="" />
						</div>
						<div className="c-hybBoxTitle">Safely lend to more creditworthy borrowers</div>
						<ul className="c-hybBoxList">
							<li>Predict risk and price it accurately</li>
							<li>Risk-appropriately increase approvals</li>
							<li>maintain full command of your credit policy</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</section>
  )
}

export default LenderWhatYouGain